import DataExportLayout from './dataExportLayout.js';

export default DataExportLayout;
